import * as React from 'react';
import BidLimitExceededMessage from '@/components/BidLimitExceededMessage/BidLimitExceededMessage';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    id: string;
    openSendSellerMessageModal: Function;
    phoneNumber: string;
    sellerId: number;
    sellerName: string;
};

const BidLimitExceededPopover = ({ id, openSendSellerMessageModal, phoneNumber, sellerId, sellerName }: Props) => {
    return (
        <StyledPopover click placement="left" trigger={<FontAwesomeIcon icon={faInfoCircle} />}>
            <div id={id}>
                <Text colorPrimaryWeak secondary>
                    <BidLimitExceededMessage
                        openSendSellerMessageModal={openSendSellerMessageModal}
                        phoneNumber={phoneNumber}
                        sellerId={sellerId}
                        sellerName={sellerName}
                    />
                </Text>
            </div>
        </StyledPopover>
    );
};

export default BidLimitExceededPopover;

const StyledPopover = styled(Popover)`
    width: 256px;
    padding: 5px;
`;
